<div class="header">
  <div class="title">
    <h2>Liste des offres du club</h2>
  </div>

  <div class="search_offer">

    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher une offre ..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
      </form>

      <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
      <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

    </div>
  </div>
</div>

<div class="content">
  <div class="list_offers_column" *ngIf="!isLoading">
    <span class="qunatity_offers"><strong>{{offers?.length}}</strong> {{offers?.length > 1 ? 'offres' : 'offre'}}</span>
    <div class="list_offers_content">
      <ngx-simplebar>
        <ng-container *ngFor="let o of offersFiltered?.length? offersFiltered : offers">
          <div class="list_offers_item" *ngIf="isInInBasket(o)"
            [ngClass]="{border_offer: offerPreview.offerKey === o.offerKey}">
            <div class="img">
              <mat-checkbox [color]="color" (change)="addOrDelteToBasket(o, $event)"></mat-checkbox>
              <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'100%'"></app-image-offer>

              <!-- <img [src]="getImgUrl(o)" [alt]="o.offerName"> -->
            </div>
            <div class="list_offers_description">

              <div class="offer_action">
                <fa-icon class="faInfoCircle" *ngIf="offerPreview.offerKey !== o.offerKey"
                  [icon]="getFaIcon('faInfoCircle')" (click)="changeOfferPreview(o)"></fa-icon>
              </div>
              <div class="description">
                <h4>{{o.offerName}}</h4>
                <p [innerHTML]="o.description">
                  <!-- {{o.description | textDescription}} -->
                </p>
              </div>
              <div class="price">
                à partir de {{o.fixedPrice}}€
              </div>
            </div>
          </div>
        </ng-container>
      </ngx-simplebar>
    </div>

    <div class="offer_sessions">
      <h4>Sessions de l'offre: <strong>{{offerPreview?.offerName}}</strong></h4>

      <div class="sessions_list" *ngIf="sessions?.length">

        <div class="session_list_header">
          <div>Label</div>
          <div>Début</div>
          <div>Fin</div>
          <div class="text_center trainee_reduce">Places</div>
          <!-- <div>Éditer</div> -->
        </div>

        <ngx-simplebar class="session_list_content">

          <ng-container *ngFor="let s of sessions">
            <div class="session_line" *ngIf="s.sessionStartDate !== '0001-01-01T00:00:00Z'">
              <div class="labelSession" [matTooltip]="s.dateLib">{{s.dateLib}}</div>
              <div>{{ s.sessionStartDate !== '0001-01-01T00:00:00Z' ? (s.sessionStartDate | date: 'shortDate':'UTC') :
                '-'}}
              </div>
              <div>{{ s.sessionEndDate !== '0001-01-01T00:00:00Z' ? (s.sessionEndDate | date: 'shortDate':'UTC') : '-'}}
              </div>
              <div class="text_center session_quantity">
                <span *ngIf="s.bookedSessionTrainees !==s.quantity">{{s.quantity - s.bookedSessionTrainees}}</span>
                <span *ngIf="s.bookedSessionTrainees ===s.quantity" class="session_complete">Complète</span>
              </div>
              <!-- <div class="text_center">
                  <fa-icon [icon]="getFaIcon('faPen')"></fa-icon>
                </div> -->
            </div>
          </ng-container>

        </ngx-simplebar>

      </div>

      <div class="no_session" *ngIf="!sessions?.length">
        <div>
          <p>Il n'y a aucune session pour cette offre.</p>
          <button>Ajouter une session</button>
        </div>
      </div>
    </div>

  </div>
  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

  <div class="list_basket_column">
    <h4>
      <fa-icon [icon]="getFaIcon('faShoppingBasket')"></fa-icon>
      Panier
    </h4>

    <ngx-simplebar class="list_basket_column_content">
      <div class="list_offers_item_basket" *ngFor="let o of basket"
        [ngClass]="{border_offer: offerPreview?.offerKey === o?.offerKey}" appChangeColorTheme attribute="border"
        borderPx="2px">
        <div class="img">
          <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'100%'"></app-image-offer>

          <!-- <img [src]="getImgUrl(o)" [alt]="o.offerName"> -->
        </div>
        <div class="list_offers_description">
          <div class="offer_action">
            <fa-icon class="faInfoCircle" *ngIf="offerPreview?.offerKey !== o?.offerKey"
              [icon]="getFaIcon('faInfoCircle')" (click)="changeOfferPreview(o)"></fa-icon>

            <fa-icon [icon]="getFaIcon('faTrashAlt')" class="faTrashAlt" (click)="addOrDelteToBasket(o)"></fa-icon>
          </div>
          <div>
            <h4>{{o.offerName}}</h4>
            <p [innerHTML]="o?.description" class="description">
              <!-- {{o.description | textDescription}} -->
            </p>
          </div>
          <div class="price">
            à partir de {{o.fixedPrice}}€
          </div>
        </div>
      </div>
    </ngx-simplebar>
  </div>

</div>

<div class="btn_action">
  <button type="button" class="confirm" (click)="closeDialog()" appChangeColorTheme attribute="bgc">Fermer</button>
</div>